// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"leesItemMobile-module--wrapper--3ta2C","beeld":"leesItemMobile-module--beeld--3lGWJ","info":"leesItemMobile-module--info--1AiLk"};